module.exports = __webpack_public_path__ + "img/bigpack-active.bb04169d.svg";